// import package
import React from 'react';

// import component
import HomeBanner from './HomeBanner';
import MarketTrend from './MarketTrend';


const Home = () => {
    return (
        <>
            <HomeBanner />
            {/* <MarketTrend /> */}
            
        </>
    )
}

export default Home;